<template>
  <div class="container">
    <h1>Valet Parking - Reservaciones Confirmadas</h1>

    <!-- Selector de fecha -->
    <div class="date-picker">
      <label for="date">Selecciona un día:</label>
      <input type="date" v-model="selectedDate" @change="filterReservations" />
    </div>

    <!-- Calendario para escritorio -->
    <div class="calendar-container" v-if="!isMobileView">
      <FullCalendar :options="calendarOptions" class="calendar" />
    </div>

    <!-- Lista de reservas para móviles -->
    <div class="reservations-list" v-else>
      <ul>
        <li v-for="res in filteredReservations" :key="res.id">
          <strong>{{ formatTime(res.time) }}</strong>: {{ res.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/init';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

export default {
  name: 'ValetParkingView',
  components: {
    FullCalendar,
  },
  setup() {
    const reservations = ref([]);
    const filteredReservations = ref([]);
    const selectedDate = ref(new Date().toISOString().split('T')[0]); // Fecha actual por defecto

    const calendarOptions = ref({
      plugins: [dayGridPlugin, timeGridPlugin],
      initialView: 'timeGridDay',
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      },
      events: [],
    });

    const isMobileView = ref(window.innerWidth <= 768);

    const handleResize = () => {
      isMobileView.value = window.innerWidth <= 768;
    };

    window.addEventListener('resize', handleResize);

    onMounted(() => {
      const q = collection(db, 'reservations');

      onSnapshot(q, (snapshot) => {
        if (!snapshot.empty) {
          reservations.value = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          filterReservations();
          calendarOptions.value.events = reservations.value.map((res) => ({
            id: res.id,
            title: res.name,
            start: `${res.date}T${res.time}`,
          }));
        }
      });
    });

    const formatTime = (time) => {
      const [hour, minute] = time.split(':');
      const hour12 = hour % 12 || 12; // Convertir a formato de 12 horas
      const suffix = hour < 12 ? 'AM' : 'PM';
      return `${hour12}:${minute} ${suffix}`;
    };

    const filterReservations = () => {
      filteredReservations.value = reservations.value
        .filter((res) => res.date === selectedDate.value)
        .sort((a, b) => a.time.localeCompare(b.time)); // Ordenar por horario
    };

    return {
      calendarOptions,
      reservations,
      filteredReservations,
      selectedDate,
      formatTime,
      isMobileView,
      filterReservations,
    };
  },
};
</script>

<style scoped src="./ValetParkingView.css"></style>
